import { inject, injectable } from 'inversify';
import Debug from 'debug';
import { QueryInteractionStatesTrackingQuery, QueryInteractionStatesTrackingQueryPayload,
         InteractionState } from '../api'
import { InteractionSuspendDataStore2 } from '../common';
import { QueryHandler } from '@/app/tracking/common';

const debug = Debug('scorm2004-query-interaction-states-query-handler')

@injectable()
export class Scorm2004QueryInteractionStatesQueryHandler implements QueryHandler<QueryInteractionStatesTrackingQuery> {

  constructor (
    @inject(InteractionSuspendDataStore2)
    private store: InteractionSuspendDataStore2,
  ) {}
  
  public async execute(query: QueryInteractionStatesTrackingQueryPayload) {

    debug('execute', query)

    const interactionStates = await this.store.query('all')
    debug('tracking interaction states', interactionStates)
    const mapped = interactionStates.map(x => {
      const state: InteractionState = {
        id: x.id,
        state: x.state,
        type: x.type
      }
      return state
    })

    debug('mapped interaction states', mapped)

    return { interactionStates: mapped }
  }
}
